export default __webpack_public_path__ + "static/media/A3.617bce15.mp3";